import React from 'react';
import { CTASection } from '../../components/CTASection';
export function AICTA() {
  return <section className="py-20 bg-white" data-id="element-210">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <CTASection headline="Ready to Leverage AI?" body="Let's discuss how AI and automation can transform your business operations." buttonText="Discuss Your AI Project" buttonLink="/contact" variant="dark" data-id="element-212" />
      </div>
    </section>;
}